import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";
import { useState } from "react";

/**
 * Generar reporte de productos Odoo con columnas dinámicas para linkedTo
 * @param {string} enterpriseId - ID de la empresa
 * @param {string} fileType - Tipo de archivo (xlsx, csv)
 * @param {string} pricelistName - Nombres de tarifas separados por comas (opcional)
 * @param {object} filter - Filtros adicionales (opcional)
 */
export const getOdooProductsReport = async (enterpriseId, fileType, pricelistName = '', filter = {}) => {
  try {
    const url = new URL(`${apiRoutes.odoo.report}/${enterpriseId}/products/${fileType}`);
    
    if (pricelistName) {
      url.searchParams.append('pricelistName', pricelistName);
    }
    
    if (Object.keys(filter).length > 0) {
      url.searchParams.append('filter', JSON.stringify(filter));
    }
    
    return await api.get(url.toString());
  } catch (error) {
    console.error('Error al generar reporte de productos Odoo:', error);
    throw error;
  }
};

export const getOdooProductsByIds = async (enterpriseId, odooProductIds) => {
    try {
      const url = `${apiRoutes.odoo.getProductsByIds}/${enterpriseId}`;
      console.log('URL de productos Odoo:', url);
      console.log('IDs enviados:', odooProductIds);
      
      const response = await api.post(url, {
        odooProductIds: odooProductIds
      });
      
      return response;
    } catch (error) {
      console.error('Error en getOdooProductsByIds:', error);
      throw error;
    }
  };
  
  // Hook para manejar productos de Odoo
  export const useOdooProducts = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [productsData, setProductsData] = useState([]);
  
    const fetchProductsByIds = async (enterpriseId, odooProductIds) => {
      if (!odooProductIds || odooProductIds.length === 0) {
        console.warn('No se proporcionaron IDs de productos');
        return [];
      }
  
      setLoading(true);
      setError(null);
      
      try {
        const response = await getOdooProductsByIds(enterpriseId, odooProductIds);
        console.log('=== DEBUG: Respuesta completa productos Odoo ===');
        console.log('response:', response);
        console.log('response.data:', response.data);
        console.log('response.data.data:', response.data?.data);
        console.log('response.data.data.products:', response.data?.data?.products);
        
        // Extraer los datos de productos de la respuesta
        let products = [];
        
        if (response.data && response.data.data && response.data.data.products) {
          // Caso: múltiples productos en array
          products = response.data.data.products;
          console.log('=== Productos extraídos desde response.data.data.products ===');
        } else if (response.data && response.data.products) {
          // Caso: múltiples productos en array (estructura alternativa)
          products = response.data.products;
          console.log('=== Productos extraídos desde response.data.products ===');
        } else if (response.data && response.data.data && response.data.data._id) {
          // Caso: un solo producto directamente en response.data.data
          products = [response.data.data];
          console.log('=== Producto único extraído desde response.data.data ===');
        } else if (response.data && response.data._id) {
          // Caso: un solo producto directamente en response.data
          products = [response.data];
          console.log('=== Producto único extraído desde response.data ===');
        } else if (response.data && response.data.data) {
          // Caso: data.data es array o contiene productos
          products = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
          console.log('=== Productos extraídos desde response.data.data (fallback) ===');
        } else if (response.data) {
          // Caso: response.data es array o contiene productos
          products = Array.isArray(response.data) ? response.data : [response.data];
          console.log('=== Productos extraídos desde response.data (fallback) ===');
        }
        
        console.log('=== Productos finales extraídos ===');
        console.log('products:', products);
        console.log('products.length:', products?.length);
        console.log('typeof products:', typeof products);
        console.log('Array.isArray(products):', Array.isArray(products));
        
        setProductsData(products);
        setLoading(false);
        
        return products;
      } catch (err) {
        console.error('Error detallado en fetchProductsByIds:', err);
        setError(err);
        setLoading(false);
        throw err;
      }
    };
  
    const clearProductsData = () => {
      setProductsData([]);
      setError(null);
    };
  
    return {
      // Estados
      loading,
      error,
      productsData,
      
      // Métodos
      fetchProductsByIds,
      clearProductsData,
      setProductsData
    };
  }; 

export const getOrderData = async (entId,numOrder)=>{
    const url = `${apiRoutes.instapago.pay}/${entId}/bill-info`
    try {
        return (await api.post(url,{billName: numOrder}))?.data.data;
    } catch (error) {
        console.log(error)   
    }
}

export const consolidationWithOdoo = async (data)=>{
    const url = `${apiRoutes.instapago.pay}/5f1378dcef2f752aeda16673/create-payment`;
    try {
        // Esta ruta es completamente libre, no requiere autenticación
        return (await api.post(url, data))?.data.data;
    } catch (error) {
        console.log(error)   
    }
}

export const getOdooAttributes = async (entId, options = {}) => {
    // Validar que entId exista antes de construir la URL
    if (!entId) {
        const error = new Error('entId es requerido para obtener atributos de Odoo');
        console.error('Error en getOdooAttributes:', error);
        throw error;
    }
    
    console.log(entId,'entId odoooooooooooooo');
    const { limit = 10, offset = 0, searchText = '' } = options;
    let url = `${apiRoutes.product.base}/attributes/odoo/${entId}?limit=${limit}&offset=${offset}`;
    
    // Agregar parámetro de búsqueda si existe
    if (searchText && searchText.trim()) {
        url += `&searchText=${encodeURIComponent(searchText.trim())}`;
    }
    
    try {
        const response = await api.get(url);
        return response?.data.data;
    } catch (error) {
        console.error('Error en getOdooAttributes:', error);
        // Lanzar el error para que pueda ser manejado en el componente
        throw error;
    }
}

export const getOdooValueAttributes = async (entId,value, searchText) => {
    const url = `${apiRoutes.odoo.getOrderData}/${entId}/attributes/values?attributeId=${value}&searchText=${searchText}`;
    try {
        return (await api.get(url))?.data.data;
    } catch (error) {
        console.log(error);
    }
}

export const getOdooCategories = async (entId, pageItemCount = 256, pageNumber = 1) => {
    const url = `${apiRoutes.odoo.getOrderData}/odooCategoriesList`;
    try {
        const response = await api.post(url, {
            entId,
            pageItemCount,
            pageNumber
        });
        return response?.data.data;
    } catch (error) {
        console.log(error);
    }
}


export const createProviderRequest = async (entId, requestData) => {
    const url = `${apiRoutes.product.base}/provider-request/${entId}`;
    try {
        return (await api.post(url, { ...requestData }))?.data.data;
    } catch (error) {
        console.log(error);
    }
}

export const getProviderRequest = async (entId, pageNumber = 1, pageItemCount = 10, status, ownerId) => {
    let url = `${apiRoutes.product.base}/provider-requests/${entId}?pageNumber=${pageNumber}&pageItemCount=${pageItemCount}`;
    if (status) {
        url += `&status=${status}`;
    }
    if (ownerId) {
        url += `&ownerId=${ownerId}`;
    }
    try {
        return (await api.get(url))?.data.data;
    } catch (error) {
        console.log(error);
    }
}

export const rejectProviderRequest = async (entId, productCreationRequestId, rejectionMessage) => {
    const url = `${apiRoutes.product.base}/provider-request/reject/${entId}`;
    console.log(url,'url');
    console.log(productCreationRequestId,'productCreationRequestId');
    console.log(rejectionMessage,'rejectionMessage');
    try {
        return (await api.put(url, { 
            productCreationRequestId: productCreationRequestId,
            rejectionMessage 
        }, {}))?.data.data;
    } catch (error) {
        console.log(error);
    }
}

export const cancelProviderRequest = async (entId, productCreationRequestId, rejectionMessage) => {
  const url = `${apiRoutes.product.base}/provider-request/cancel/${entId}`;
  console.log(url,'url');
  console.log(productCreationRequestId,'productCreationRequestId');
  console.log(rejectionMessage,'rejectionMessage');
  try {
      return (await api.put(url, { 
          productCreationRequestId,
          rejectionMessage 
      }, {}))?.data.data;
  } catch (error) {
      console.log(error);
  }
}

export const approveProviderRequest = async (entId, productCreationRequestId) => {
  const url = `${apiRoutes.product.base}/variants/create/${entId}`;
  try {
      return (await api.post(url, { 
          productCreationRequestId: Array.isArray(productCreationRequestId) ? productCreationRequestId : [productCreationRequestId]
      }))?.data.data;
  } catch (error) {
      console.log(error);
  }
}

export const getOdooBrands = async (entId, searchText) => {
  const url = `${apiRoutes.providers.base}/${entId}/search-brands-by-name?brandName=${searchText}`;
  try {
      return (await api.get(url))?.data.data;
  } catch (error) {
      console.log(error);
  }
}

export const getOdooCategoriesWeb = async (entId, searchText) => {
  const url = `${apiRoutes.providers.base}/${entId}/search-web-categories-by-name?categoryName=${searchText}`;
  try {
      return (await api.get(url))?.data.data;
  } catch (error) {
      console.log(error);
  }
}

export const createProviderClient = async (entId, requestData, token) => {
  const url = `${apiRoutes.providers.base}/${entId}/suppliers/create-in-odoo?token=${token}`;
  console.log(url,'url');
  console.log(requestData,'requestData');
  try {
      const response = await api.post(url, { ...requestData });
      console.log(response,'response0000');
      return response?.data?.data || response;
  } catch (error) {
      console.log('Error en createProviderClient:', error);
      console.log('Error response data:', error.response?.data);
      // Lanzar el error para que pueda ser manejado en el componente
      throw error;
  }
}

export const generatePublicTempUrl = async (entId) => {
  const url = `${apiRoutes.providers.base}/${entId}/generate-public-temp-url`;
  try {
      const response = await api.post(url);
      console.log(response,'response00001212');
      return response?.data?.data || response;
  } catch (error) {
      console.log('Error en generatePublicTempUrl:', error);
      console.log('Error response data:', error.response?.data);
      // Lanzar el error para que pueda ser manejado en el componente
      throw error;
  }
}

export const getOdooPublicTempUrl = async (entId, page = 1, limit = 10, token) => {
  const url = `${apiRoutes.providers.base}/${entId}/token-status`;

  try {
      const params = {
        page,
        limit
      };
      
      // Agregar token a los params si existe
      if (token) {
        params.token = token;
      }
      
      const response = await api.get(url, {
        params
      });
      console.log(response,'getOdooPublicTempUrl');
      return response?.data?.data || response;
  } catch (error) {
      console.log('Error en getOdooPublicTempUrl:', error);
      console.log('Error response data:', error.response?.data);
      // Lanzar el error para que pueda ser manejado en el componente
      throw error;
  }
}

export const getProviderLogs = async (entId, pageNumber = 1, pageItemCount = 10) => {
  const url = `${apiRoutes.providers.base}/owners-logs-registers`;
  try {
      const response = await api.get(url, {
        params: {
          pageNumber,
          pageItemCount
        }
      });
      console.log('Response de getProviderLogs:', response);
      return response?.data?.data || response?.data || response;
  } catch (error) {
      console.log('Error en getProviderLogs:', error);
      throw error;
  }
}

export const generateBulkPublicTempUrls = async (entId, quantity, expiresIn = 60) => {
  const url = `${apiRoutes.providers.base}/${entId}/generate-bulk-public-temp-urls`;
  try {
      const response = await api.post(url, {
        quantity,
        expiresIn
      });
      console.log('Response de generateBulkPublicTempUrls:', response);
      return response?.data?.data || response?.data || response;
  } catch (error) {
      console.log('Error en generateBulkPublicTempUrls:', error);
      console.log('Error response data:', error.response?.data);
      throw error;
  }
}

export const cancelProviderLink = async (entId, token) => {
  const url = `${apiRoutes.providers.base}/${entId}/cancel-link`;
  try {
      const response = await api.post(url, {
        token
      });
      console.log('Response de cancelProviderLink:', response);
      return response?.data?.data || response?.data || response;
  } catch (error) {
      console.log('Error en cancelProviderLink:', error);
      console.log('Error response data:', error.response?.data);
      throw error;
  }
}